import { Card, CardContent } from "@/components/ui/card";
import {
  formatFundingMoney,
  type FundingEstimate,
} from "@/lib/calculators/acquisition-funding";

/** Keeps the answer in view while editing a stacked calculator on small screens. */
export function FundingSummary({
  result,
  currency,
  compact,
}: {
  result: FundingEstimate | null;
  currency: string;
  compact: boolean;
}) {
  return (
    <div
      className={`sticky top-[calc(var(--banner-height)+4rem)] z-10 ${compact ? "" : "lg:hidden"}`}
      aria-hidden="true"
    >
      <Card className="border-border shadow-sm">
        <CardContent className="p-4">
          {result ? (
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-xs text-muted-foreground">
                  Your cash ({currency})
                </p>
                <p className="mt-1 break-words font-display text-xl font-medium tabular-nums">
                  {formatFundingMoney(result.buyerCash, currency)}
                </p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">
                  Loan payments / month
                </p>
                <p className="mt-1 break-words font-display text-xl font-medium tabular-nums">
                  {formatFundingMoney(result.monthly, currency, 2)}
                </p>
              </div>
            </div>
          ) : (
            <p className="text-sm">
              Check the highlighted inputs to calculate your scenario.
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
